var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('FindForm',{attrs:{"version":2}}),_c('Discover'),_c('Carousel'),_c('Specialization'),_c('MultiRegister')],1)}
var staticRenderFns = []

export { render, staticRenderFns }